// Section 3 — Salary Outcomes.
// NOTE TO AJAYE: verify these figures before launch against the cited source
// documents. Current values are reasonable ranges from public data and should
// be source-confirmed.
const ROWS = [
  { icon: '🛠️', cert: 'CompTIA A+',       salary: '$52,000',  role: 'IT Support Specialist, Help Desk' },
  { icon: '🌐', cert: 'CompTIA Network+', salary: '$68,000',  role: 'Network Administrator' },
  { icon: '🔒', cert: 'CompTIA Security+', salary: '$85,000',  role: 'Security Analyst' },
  { icon: '☁️', cert: 'Microsoft AZ-104',  salary: '$95,000+', role: 'Azure Administrator' },
];

export default function SalaryOutcomesSection() {
  return (
    <section className="so-sec">
      <div className="so-inner">
        <h2 className="so-h2">And the career outcome is real.</h2>
        <p className="so-sub">
          Entry-level IT certifications open doors to high-paying roles &mdash;
          and they lead to higher salaries as you gain more certifications and
          experience. A lot of our students start their first IT Role with entry
          level certification and get into a higher salary by getting their next
          few certifications while working their first IT Job.
        </p>

        <div className="so-grid" role="table" aria-label="Certification salary outcomes">
          <div className="so-head" role="row">
            <span role="columnheader">Certification</span>
            <span role="columnheader">Avg. Starting Salary</span>
            <span role="columnheader">Role</span>
          </div>
          {ROWS.map(r => (
            <div className="so-row" role="row" key={r.cert}>
              <span className="so-cert" role="cell">
                <span className="so-ico" aria-hidden="true">{r.icon}</span>
                {r.cert}
              </span>
              <span className="so-salary" role="cell">{r.salary}</span>
              <span className="so-role" role="cell">{r.role}</span>
            </div>
          ))}
        </div>

        <p className="so-cite">
          Sources: CompTIA IT Salary Report 2025, BLS Occupational Outlook
          Handbook, Robert Half Technology Salary Guide.
        </p>
      </div>

      <style>{`
        .so-sec { position: relative; z-index: 1; padding: clamp(48px, 8vh, 96px) clamp(16px, 4vw, 40px); }
        .so-inner { max-width: 1000px; margin: 0 auto; }
        .so-h2 {
          font-family: 'Fraunces', serif; font-weight: 500;
          font-size: clamp(28px, 4vw, 44px); line-height: 1.1;
          letter-spacing: -0.02em; margin: 0; text-align: center;
        }
        .so-sub {
          font-weight: 300; color: rgba(17,17,16,0.62);
          font-size: clamp(16px, 2vw, 20px); line-height: 1.5;
          margin: 18px auto 0; max-width: 54ch; text-align: center;
        }
        .so-grid {
          margin-top: clamp(32px, 5vw, 48px);
          border: 1px solid rgba(0,0,0,0.08); border-radius: 16px;
          overflow: hidden; background: #ffffff; box-shadow: 0 4px 20px rgba(0,0,0,0.05);
        }
        .so-head, .so-row {
          display: grid; grid-template-columns: 1.1fr 0.9fr 1.4fr;
          align-items: center; gap: 16px; padding: 16px clamp(16px, 2.5vw, 26px);
        }
        .so-head {
          font-size: 12px; font-weight: 700; text-transform: uppercase;
          letter-spacing: .07em; color: rgba(17,17,16,0.5);
          background: rgba(0,0,0,0.03);
          border-bottom: 1px solid rgba(0,0,0,0.07);
        }
        .so-row { border-bottom: 1px solid rgba(0,0,0,0.05); transition: background .18s ease; }
        .so-row:last-child { border-bottom: none; }
        .so-row:hover { background: rgba(217,119,6,0.04); }
        .so-cert { display: flex; align-items: center; gap: 11px; font-size: 16px; font-weight: 600; color: #111110; }
        .so-ico { font-size: 18px; }
        .so-salary {
          font-size: clamp(17px, 2vw, 21px); font-weight: 700; color: #059669;
          font-variant-numeric: tabular-nums;
        }
        .so-role { font-size: 14px; color: rgba(17,17,16,0.66); line-height: 1.35; }
        .so-cite {
          margin: 18px 0 0; font-size: 12.5px; color: rgba(17,17,16,0.4);
          line-height: 1.5; text-align: center;
        }
        @media (max-width: 720px) {
          .so-head { display: none; }
          .so-row {
            grid-template-columns: 1fr; gap: 6px;
            padding: 16px 18px; border-bottom: 1px solid rgba(0,0,0,0.07);
          }
          .so-salary { font-size: 20px; }
          .so-role { font-size: 13.5px; }
        }
      `}</style>
    </section>
  );
}
